// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"7e63d871e474c3ee","2931":"334743beb05fb485","4199":"4e1ae38206798e2b","6793":"f57464ca23fa9330"}[chunkId] + ".js";
};